import React, { useState } from "react";
import { Button } from "@mui/material";
import SeeDetailsDrawer from "./SeeDetailsDrawer"; // Import your drawer component

// This is a new component to handle the state and actions
const SeeDetailsButton = () => {
  const [seeDetailDrawerOpen, setSeeDetailDrawerOpen] = useState(false);

  // Toggle the drawer visibility
  const toggleSeeDetail = () => {
    setSeeDetailDrawerOpen(!seeDetailDrawerOpen);
  };

  return (
    <>
      <Button
        sx={{
          color: "rgba(28, 38, 48, 1)",
          border: "1px solid rgba(229, 229, 232, 1)",
          height: "33px",
          fontWeight: "600 !important",
          ':hover': {
            backgroundColor: "white"
          }
        }}
        onClick={toggleSeeDetail}
      >
        See Details
      </Button>

      {seeDetailDrawerOpen && (
        <SeeDetailsDrawer
          open={seeDetailDrawerOpen}
          onClose={toggleSeeDetail} // Close the drawer when the action is triggered
        />
      )}
    </>
  );
};

export default SeeDetailsButton;
